import { Colors } from '@lightningjs/sdk';
import PublicRoute from '../../components/layouts/PublicRoute/PublicRoute';

export default class NotFound extends PublicRoute {
  static _template() {
    return {
      _testId: 'NotFound',
      title: 'Not Found',
      ...super._template(),
      SectionsContainer: {
        x: 30,
        y: 30,
        Title: {
          text: {
            text: '404 Page Not Found',
            textColor: Colors('#ffffff').get(),
          },
        },
      },
    };
  }

  _getFocused() {
    return this;
  }
}
